import React from 'react';
import PropTypes from 'prop-types';

import * as S from '@/components/HeaderHero/styled';

export const HeroContent = ({ title, readMore }) => {
  return (
    <S.HeroContent>
      <S.HeroTitle>{title}</S.HeroTitle>
      {readMore && <S.HeroCTA role="link">{readMore}</S.HeroCTA>}
    </S.HeroContent>
  );
};

HeroContent.propTypes = {
  title: PropTypes.string.isRequired,
  readMore: PropTypes.string.isRequired,
};
